/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'feature/store';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/feature/store/v1/features/defaults/{i18nLangLocale}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:FeaturesResource+type:symbol+getGrowthFeaturesWithDefaultsNoAuth&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Features-get-%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fdefaults%2F%7Bi18nLangLocale%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fdefaults%2F%28%28%7Bi18nLangLocale%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getGrowthFeaturesWithDefaultsNoAuthRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/features/defaults', pathParameterPlaceholder]),
  pathParameters: freeze(['i18nLangLocale'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/feature/store/v1/features/by-short-name/translated/{shortName}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:FeaturesResource+type:symbol+getTranslatedGrowthFeature&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Features-get-%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-short-name%2Ftranslated%2F%7BshortName%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-short-name%2Ftranslated%2F%28%28%7BshortName%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getTranslatedGrowthFeatureRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/features/by-short-name/translated', pathParameterPlaceholder]),
  pathParameters: freeze(['shortName'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/feature/store/v1/features/by-api-names/translated
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:FeaturesResource+type:symbol+getTranslatedGrowthFeaturesFromProducts&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Features-get-%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-api-names%2Ftranslated'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-api-names%2Ftranslated?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getTranslatedGrowthFeaturesFromProductsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/features/by-api-names/translated'])
});